import { PublicPage } from 'api/website';

type Props = {
  content: PublicPage;
};

export function getContentLocaleUrl({
  content,
}: Props): Record<string, string> {
  return (
    content.translations &&
    content.translations.reduce(
      (acc, cur) => {
        // eslint-disable-next-line no-param-reassign
        acc[cur.locale] = `/${cur.url}`;
        return acc;
      },
      {
        [content.locale]: `/${content.url}`,
      }
    )
  );
}
